var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brain-task-toast"},[_c('BrainTaskToastHeader',{attrs:{"icon":['fal', 'code-merge'],"title":_vm.$t(`${_vm.i18n}.title`),"closable":_vm.closable},on:{"close":function($event){return _vm.$emit('close')}}}),_c('BrainTaskToastBody',{attrs:{"status":_vm.status,"status-configs":_vm.statusConfigs},on:{"click:cta":_vm.handleCTA}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }